import React, { useState, useEffect } from "react";
import { Modal } from "@components";
import { RequestForAttestation, getRequestForAttestation } from "@api";
import { Typography, makeStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles({
  pointer: {
    cursor: "pointer",
  },
});

interface Props {
  isOpen: boolean;
  closeModal: () => void;
}

export const AttestationModal: React.FC<Props> = ({ isOpen, closeModal }) => {
  const [requests, setRequests] = useState<RequestForAttestation[]>([]);
  const history = useHistory();
  const classes = useStyles();

  useEffect(() => {
    getRequestForAttestation()
      .then((data) => {
        setRequests(data);
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      closeModal={closeModal}
      title="For User Agreement (Attestation)"
    >
      {requests.map(({ referenceNumber, encryptId }: RequestForAttestation) => {
        return (
          <Typography
            key={encryptId}
            variant="body1"
            color="primary"
            className={classes.pointer}
            onClick={() =>
              history.push(
                `/dashboard/requests/${encryptId}/accept-attestation`
              )
            }
          >
            {referenceNumber}
          </Typography>
        );
      })}
    </Modal>
  );
};
